import { useQuery } from 'react-query';
import { getApi } from '../../../../config/SwaggerApi';
import { configQueryReactSimpleRequest } from '../../../core/hooks/useCodeTables/config';



const codeTableAttributesQueryFn = (workspaceName: string, applicationCode?: string) => {
    return getApi().asite.asiteGetAsiteAttributesProductReservationGet({
        workspaceName, applicationCode
    })
        .then((response) => response.data);
}


const useCodeTableAttributesQuery = (workspaceName: string, applicationCode?: string, documentLink?: boolean) => {
    const codeTableAttributesQuery = useQuery(
        ['codeTable-attributes', workspaceName, applicationCode, documentLink],
        () => codeTableAttributesQueryFn(workspaceName, applicationCode),
        { ...configQueryReactSimpleRequest, enabled: !!workspaceName }
    );

    return codeTableAttributesQuery;
};

export default useCodeTableAttributesQuery;
